import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, shareReplay} from 'rxjs';
import {unauthenticated} from '@datev/ngx-dcal';
import {environment} from 'projects/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DocumentStoreService {
  private readonly baseUrl = environment.downloadDetailsDocViewerBaseUrl;

  constructor(private readonly httpClient: HttpClient) {}

  getPdfBuffer(documentId: string): Observable<ArrayBuffer> {
    return this.httpClient.get(
      `${this.baseUrl}${documentId}`,
      {
        context: unauthenticated(),
        responseType: 'arraybuffer',
      },
    ).pipe(
      shareReplay(1)
    );
  }
}
